// Image read + canvas resize/compress for uploads

export function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise<string>(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () { resolve(String(reader.result || '')); };
    reader.onerror = function (e) { reject(e); };
    reader.readAsDataURL(file);
  });
}

// Сжатие изображений перед загрузкой (уменьшаем размер, оставляя приемлемое качество)
export function compressImageFile(file: File, maxSize?: number, quality?: number): Promise<string> {
  maxSize = maxSize || 1280;
  quality = quality || 0.8;
  return new Promise<string>(function (resolve, reject) {
    readFileAsDataUrl(file).then(function (dataUrl: string) {
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.width;
          var h = img.height;
          if (!w || !h) {
            return resolve(dataUrl);
          }
          var scale = 1;
          if (w > h && w > maxSize) scale = maxSize / w;
          else if (h >= w && h > maxSize) scale = maxSize / h;
          if (scale >= 1) {
            return resolve(dataUrl);
          }
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(w * scale);
          canvas.height = Math.round(h * scale);
          var ctx = canvas.getContext('2d');
          if (!ctx) {
            return resolve(dataUrl);
          }
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          try {
            var compressed = canvas.toDataURL('image/jpeg', quality);
            resolve(compressed && compressed.length < dataUrl.length ? compressed : dataUrl);
          } catch (_) {
            resolve(dataUrl);
          }
        } catch (_) {
          resolve(dataUrl);
        }
      };
      img.onerror = function (e) { reject(e); };
      img.src = dataUrl;
    }).catch(reject);
  });
}
